module.exports = __webpack_public_path__ + "static/img/case_tab_03.7b5c32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_03.png
// module id = kmWj
// module chunks = 34